var _Piano_midi;
import { __classPrivateFieldGet, __classPrivateFieldSet, __rest } from "tslib";
import { Constants } from './constants';
export class Piano {
    constructor(midi, debug = false) {
        this.debug = debug;
        _Piano_midi.set(this, null);
        this.bpm = 120;
        this.multiplier = 1;
        __classPrivateFieldSet(this, _Piano_midi, midi, "f");
        this.resetTempo();
    }
    resetTempo() {
        const midi = __classPrivateFieldGet(this, _Piano_midi, "f");
        if (midi.meta.type === 0)
            return;
        const tempoMessage = midi.tracks[0].messages.find(({ metaType }) => metaType === Constants.TempoMessage);
        if (!tempoMessage)
            return;
        if (midi.meta.type === 1)
            this.updateTempo(tempoMessage.data);
    }
    updateTempo(tempo) {
        this.bpm = Math.round(60000000 / tempo);
        this.multiplier = (60000 / (this.bpm * __classPrivateFieldGet(this, _Piano_midi, "f").meta.timeDivision.value));
    }
    /**
     * Automatically calls callback when note plays. Maintains tempo.
     */
    play(trackOrCallback, callback = null) {
        this.resetTempo();
        if (typeof trackOrCallback === 'function') {
            callback = trackOrCallback;
            trackOrCallback = __classPrivateFieldGet(this, _Piano_midi, "f").meta.type === 0 ? 0 : 1;
        }
        let totalTimer = 0;
        const stats = {
            highest: -Infinity,
            lowest: Infinity,
        };
        __classPrivateFieldGet(this, _Piano_midi, "f").tracks[trackOrCallback].messages.forEach(message => {
            const _a = this.read(message), { type } = _a, read = __rest(_a, ["type"]);
            if (read.note > stats.highest)
                stats.highest = read.note;
            if (read.note < stats.lowest)
                stats.lowest = read.note;
            totalTimer += read.scaledDeltaTime;
            if (type !== Piano.TypeNote)
                return;
            setTimeout(() => {
                callback(read);
            }, totalTimer);
        });
        if (this.debug)
            console.log({ stats });
    }
    read(message, updateTempo = true) {
        const { statusType, metaType, deltaTime, data, type } = message;
        const baseData = {
            deltaTime,
            scaledDeltaTime: deltaTime * this.multiplier,
        };
        // console.log(statusType);
        if (type === Constants.ControlMessage) {
            if (data[0] === 64) {
                return Object.assign(Object.assign({}, baseData), { type: Piano.TypePedal, position: data[1] === 0 ? Piano.PositionUp : Piano.PositionDown });
            }
            return Object.assign(Object.assign({}, baseData), { type: Piano.TypeUnknownControl, data, message });
        }
        if (statusType === Constants.MetaMessage) {
            // We only handle tempo changes. Other metadata is considered unknown.
            if (metaType !== Constants.TempoMessage)
                return Object.assign(Object.assign({}, baseData), { type: Piano.TypeUnknownMeta });
            if (updateTempo)
                this.updateTempo(data);
            return Object.assign(Object.assign({}, baseData), { type: Piano.TypeTempoChange });
        }
        const [note, velocity] = data;
        // Add if note on/off. Add if tempo switch.
        return Object.assign(Object.assign(Object.assign({}, baseData), this.noteInfo(note)), { type: Piano.TypeNote, position: velocity === 0 ? Piano.PositionUp : Piano.PositionDown, velocity });
    }
    noteInfo(note) {
        return Object.assign(Object.assign({ note }, Piano.Notes[(note + 3) % Piano.Notes.length]), { scale: Math.floor((note / Piano.Notes.length) - 1) });
    }
}
_Piano_midi = new WeakMap();
Piano.Notes = ['A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#'].map(n => ({
    noteName: n, isSharp: n.length === 2,
}));
Piano.TypeTempoChange = 'TYPE_TEMPO_CHANGE';
Piano.TypePedal = 'TYPE_PEDAL';
Piano.TypeNote = 'TYPE_NOTE';
Piano.TypeUnknownMeta = 'TYPE_UNKNOWN_META';
Piano.TypeUnknownControl = 'TYPE_UNKNOWN_CONTROL';
Piano.PositionUp = 'Up';
Piano.PositionDown = 'Down';
